module.exports = __webpack_public_path__ + "media/images/direct-employers-transparent-logo-5dad5145094606ef6117443e0a38eb3e.png";